module.exports = __webpack_public_path__ + "static/media/preroll_stock80.9e8d6260.jpg";